import React, { useCallback } from 'react'
import { DatePicker } from '@material-ui/pickers'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { map, size } from 'lodash'
import { WEEK_DAYS_NUMBER } from '../constants'

const CheckInDatePicker = (props) => {
  const { errors } = useFormContext()
  const { t } = useTranslation()
  const disableBookedDates = useCallback((date) => {
    let result = map(props.notAvailablePeriods, (booking) => {
      return date.isSameOrBefore(booking.endDate) && date.isSameOrAfter(booking.startDateWithMinStay)
    })
    if (size(result) === 0) {
      return false
    }
    return result.reduce((result, condition) => result || condition)
  }, [])

  const disableWeekends = (date) => {
    return date.day() === WEEK_DAYS_NUMBER.Saturday || date.day() === WEEK_DAYS_NUMBER.Sunday;
  };
  return (
    <DatePicker
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      inputVariant="outlined"
      fullWidth
      shouldDisableDate={(date) => disableBookedDates(date) || disableWeekends(date)}
      error={errors.start_date}
      format="DD-MM-yyyy"
      minDate={moment().add(20, 'days')}
      maxDate={moment().add(1, 'days').add(4, 'years')}
      label={t('booking.checkIn.dateCheckIn.placeholder')}
    />
  )
}

export default CheckInDatePicker
